<!--
백그라운드 작업 현황 — Operations Dashboard
-->
<template>
    <div class="bjs">

        <!-- ====== 상태 요약 카드 ====== -->
        <div class="bjs-stats">
            <div class="bjs-stat bjs-stat--all"
                 :class="{ 'is-active': filterStatus === '' }"
                 @click="setStatusFilter('')">
                <div class="bjs-stat__icon">
                    <svg viewBox="0 0 20 20" fill="currentColor"><path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 6a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2zm0 6a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2z"/></svg>
                </div>
                <div class="bjs-stat__body">
                    <div class="bjs-stat__count">{{ statusCountTotal }}</div>
                    <div class="bjs-stat__label">전체</div>
                </div>
            </div>
            <div class="bjs-stat bjs-stat--pending"
                 :class="{ 'is-active': filterStatus === '1' }"
                 @click="setStatusFilter('1')">
                <div class="bjs-stat__icon">
                    <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"/></svg>
                </div>
                <div class="bjs-stat__body">
                    <div class="bjs-stat__count">{{ statusCounts[1] || 0 }}</div>
                    <div class="bjs-stat__label">대기</div>
                </div>
            </div>
            <div class="bjs-stat bjs-stat--running"
                 :class="{ 'is-active': filterStatus === '2' }"
                 @click="setStatusFilter('2')">
                <div class="bjs-stat__icon">
                    <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/></svg>
                </div>
                <div class="bjs-stat__body">
                    <div class="bjs-stat__count">{{ statusCounts[2] || 0 }}</div>
                    <div class="bjs-stat__label">진행중</div>
                </div>
            </div>
            <div class="bjs-stat bjs-stat--completed"
                 :class="{ 'is-active': filterStatus === '3' }"
                 @click="setStatusFilter('3')">
                <div class="bjs-stat__icon">
                    <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
                </div>
                <div class="bjs-stat__body">
                    <div class="bjs-stat__count">{{ statusCounts[3] || 0 }}</div>
                    <div class="bjs-stat__label">완료</div>
                </div>
            </div>
            <div class="bjs-stat bjs-stat--failed"
                 :class="{ 'is-active': filterStatus === '9' }"
                 @click="setStatusFilter('9')">
                <div class="bjs-stat__icon">
                    <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>
                </div>
                <div class="bjs-stat__body">
                    <div class="bjs-stat__count">{{ statusCounts[9] || 0 }}</div>
                    <div class="bjs-stat__label">실패</div>
                </div>
            </div>
        </div>

        <!-- ====== 툴바: 필터 + 새로고침 ====== -->
        <div class="bjs-toolbar">
            <div class="bjs-toolbar__left">
                <label class="bjs-toolbar__label">작업유형</label>
                <select class="bjs-toolbar__select" v-model="filterJobType" @change="onFilterChange">
                    <option value="">전체</option>
                    <option value="1">출고운임 과금</option>
                    <option value="2">과금집행</option>
                    <option value="10">더미데이터 생성</option>
                </select>
            </div>
            <div class="bjs-toolbar__right">
                <button class="bjs-toolbar__btn" :class="{ 'is-on': autoRefresh }" @click="toggleAutoRefresh" title="자동 새로고침">
                    <svg class="bjs-toolbar__btn-icon" viewBox="0 0 16 16" fill="currentColor"><circle cx="8" cy="8" r="4"/></svg>
                    <span v-if="autoRefresh">{{ refreshCountdown }}s</span>
                    <span v-else>자동</span>
                </button>
                <button class="bjs-toolbar__btn bjs-toolbar__btn--refresh" @click="loadData" :disabled="loading" title="새로고침">
                    <svg class="bjs-toolbar__btn-icon" :class="{ 'is-spinning': loading }" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd"/>
                    </svg>
                </button>
            </div>
        </div>

        <!-- ====== 로딩 ====== -->
        <div v-if="loading" class="bjs-loading">
            <div class="bjs-loading__spinner"></div>
            <p class="bjs-loading__text">데이터를 불러오는 중...</p>
        </div>

        <!-- ====== 데이터 로드 완료 ====== -->
        <div v-else>

            <!-- 데이터 없음 -->
            <div v-if="items.length === 0" class="bjs-empty">
                <svg class="bjs-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
                </svg>
                <p class="bjs-empty__text">조회 결과가 없습니다.</p>
            </div>

            <!-- ====== 메인 테이블 ====== -->
            <div v-else class="bjs-table-wrap">
                <table class="bjs-table">
                    <thead>
                        <tr>
                            <th class="bjs-th--status"></th>
                            <th>ID</th>
                            <th>작업유형</th>
                            <th>상태</th>
                            <th>진행률</th>
                            <th>성공 / 실패</th>
                            <th>등록</th>
                            <th>시작</th>
                            <th>완료</th>
                            <th>비고</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in items"
                            :key="item.id"
                            class="bjs-row"
                            :class="[
                                'bjs-row--s' + item.status,
                                { 'is-selected': selectedItem && selectedItem.id === item.id }
                            ]"
                            @click="selectItem(item)"
                        >
                            <!-- 상태 인디케이터 -->
                            <td class="bjs-td--status">
                                <span class="bjs-dot" :class="'bjs-dot--s' + item.status"></span>
                            </td>
                            <!-- ID -->
                            <td class="bjs-td--id">{{ item.id }}</td>
                            <!-- 작업유형 -->
                            <td class="bjs-td--type">{{ item.job_type_label }}</td>
                            <!-- 상태 -->
                            <td>
                                <span class="bjs-badge" :class="'bjs-badge--s' + item.status">
                                    {{ item.status_label }}
                                </span>
                            </td>
                            <!-- 진행률 바 -->
                            <td class="bjs-td--progress">
                                <div class="bjs-progress">
                                    <div class="bjs-progress__bar"
                                         :class="'bjs-progress__bar--s' + item.status"
                                         :style="{ width: progressPercent(item) + '%' }">
                                    </div>
                                    <span class="bjs-progress__text">{{ item.processed_count }}/{{ item.total_count }}</span>
                                </div>
                            </td>
                            <!-- 성공/실패 -->
                            <td class="bjs-td--counts">
                                <span class="bjs-count-ok">{{ item.success_count }}</span>
                                <span class="bjs-count-sep">/</span>
                                <span :class="item.fail_count > 0 ? 'bjs-count-fail' : 'bjs-count-zero'">{{ item.fail_count }}</span>
                            </td>
                            <!-- 등록일시 -->
                            <td class="bjs-td--time">{{ shortTime(item.created_at) }}</td>
                            <!-- 시작일시 -->
                            <td class="bjs-td--time">{{ item.started_at ? shortTime(item.started_at) : '-' }}</td>
                            <!-- 완료일시 -->
                            <td class="bjs-td--time">{{ item.completed_at ? shortTime(item.completed_at) : '-' }}</td>
                            <!-- 비고 -->
                            <td class="bjs-td--note">
                                <span v-if="item.failed_job_id" class="bjs-note-fjid" title="failed_job_id">FJ#{{ item.failed_job_id }}</span>
                                <span v-if="item.error_message" class="bjs-note-err" :title="item.error_message">{{ truncate(item.error_message, 30) }}</span>
                                <span v-if="!item.failed_job_id && !item.error_message">-</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- 페이징 -->
                <div class="bjs-pager">
                    <button class="bjs-pager__btn" :disabled="page <= 1" @click="goPage(page - 1)">
                        <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
                    </button>
                    <span class="bjs-pager__info">{{ page }} / {{ lastPage }} <span class="bjs-pager__total">({{ total }}건)</span></span>
                    <button class="bjs-pager__btn" :disabled="page >= lastPage" @click="goPage(page + 1)">
                        <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/></svg>
                    </button>
                </div>
            </div>
        </div>

        <!-- ====== 상세 패널 ====== -->
        <transition name="bjs-slide">
        <div v-if="selectedItem" class="bjs-detail">

            <!-- 상세 헤더 -->
            <div class="bjs-detail__header">
                <div class="bjs-detail__title-row">
                    <span class="bjs-dot bjs-dot--lg" :class="'bjs-dot--s' + selectedItem.status"></span>
                    <h4 class="bjs-detail__title">#{{ selectedItem.id }} {{ selectedItem.job_type_label }}</h4>
                    <span class="bjs-badge" :class="'bjs-badge--s' + selectedItem.status">{{ selectedItem.status_label }}</span>
                </div>
                <div class="bjs-detail__actions">
                    <button
                        v-if="selectedItem.status === 9 && selectedItem.failed_job"
                        class="bjs-btn bjs-btn--danger"
                        :disabled="retrying"
                        @click="retryJob"
                    >
                        <svg class="bjs-btn__icon" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd"/>
                        </svg>
                        큐재등록
                    </button>
                    <button class="bjs-btn bjs-btn--ghost" @click="selectedItem = null">닫기</button>
                </div>
            </div>

            <!-- 메타 정보 그리드 -->
            <div class="bjs-detail__meta">
                <div class="bjs-meta-item">
                    <span class="bjs-meta-item__label">ref_id</span>
                    <span class="bjs-meta-item__value">{{ selectedItem.ref_id || '-' }}</span>
                </div>
                <div class="bjs-meta-item">
                    <span class="bjs-meta-item__label">requested_by</span>
                    <span class="bjs-meta-item__value">{{ selectedItem.requested_by || '-' }}</span>
                </div>
                <div class="bjs-meta-item">
                    <span class="bjs-meta-item__label">failed_job_id</span>
                    <span class="bjs-meta-item__value" :class="{ 'is-danger': selectedItem.failed_job_id }">{{ selectedItem.failed_job_id || '-' }}</span>
                </div>
                <div class="bjs-meta-item">
                    <span class="bjs-meta-item__label">등록</span>
                    <span class="bjs-meta-item__value">{{ selectedItem.created_at }}</span>
                </div>
                <div class="bjs-meta-item">
                    <span class="bjs-meta-item__label">시작</span>
                    <span class="bjs-meta-item__value">{{ selectedItem.started_at || '-' }}</span>
                </div>
                <div class="bjs-meta-item">
                    <span class="bjs-meta-item__label">완료</span>
                    <span class="bjs-meta-item__value">{{ selectedItem.completed_at || '-' }}</span>
                </div>
            </div>

            <!-- 진행률 상세 -->
            <div class="bjs-detail__progress-section">
                <div class="bjs-progress bjs-progress--lg">
                    <div class="bjs-progress__bar"
                         :class="'bjs-progress__bar--s' + selectedItem.status"
                         :style="{ width: progressPercent(selectedItem) + '%' }">
                    </div>
                    <span class="bjs-progress__text">{{ progressPercent(selectedItem) }}%</span>
                </div>
                <div class="bjs-detail__progress-counts">
                    <div class="bjs-progress-count">
                        <span class="bjs-progress-count__num">{{ selectedItem.total_count }}</span>
                        <span class="bjs-progress-count__label">전체</span>
                    </div>
                    <div class="bjs-progress-count">
                        <span class="bjs-progress-count__num">{{ selectedItem.processed_count }}</span>
                        <span class="bjs-progress-count__label">처리</span>
                    </div>
                    <div class="bjs-progress-count bjs-progress-count--ok">
                        <span class="bjs-progress-count__num">{{ selectedItem.success_count }}</span>
                        <span class="bjs-progress-count__label">성공</span>
                    </div>
                    <div class="bjs-progress-count bjs-progress-count--fail">
                        <span class="bjs-progress-count__num">{{ selectedItem.fail_count }}</span>
                        <span class="bjs-progress-count__label">실패</span>
                    </div>
                </div>
            </div>

            <!-- 에러 메시지 -->
            <div v-if="selectedItem.error_message" class="bjs-detail__section bjs-detail__section--error">
                <div class="bjs-section-head bjs-section-head--error">error_message</div>
                <pre class="bjs-pre bjs-pre--error">{{ selectedItem.error_message }}</pre>
            </div>

            <!-- request_data -->
            <div v-if="selectedItem.request_data" class="bjs-detail__section">
                <div class="bjs-section-head">request_data</div>
                <pre class="bjs-pre">{{ formatJson(selectedItem.request_data) }}</pre>
            </div>

            <!-- result_data -->
            <div v-if="selectedItem.result_data" class="bjs-detail__section">
                <div class="bjs-section-head">result_data</div>
                <pre class="bjs-pre">{{ formatJson(selectedItem.result_data) }}</pre>
            </div>

            <!-- ====== failed_jobs 섹션 ====== -->
            <div v-if="selectedItem.failed_job" class="bjs-detail__failed">
                <div class="bjs-detail__failed-header">
                    <svg class="bjs-detail__failed-icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>
                    <span>FAILED JOB #{{ selectedItem.failed_job.id }}</span>
                </div>

                <div class="bjs-detail__failed-meta">
                    <span><strong>connection:</strong> {{ selectedItem.failed_job.connection }}</span>
                    <span><strong>queue:</strong> {{ selectedItem.failed_job.queue }}</span>
                    <span><strong>failed_at:</strong> {{ selectedItem.failed_job.failed_at }}</span>
                </div>

                <!-- payload -->
                <div class="bjs-detail__section">
                    <div class="bjs-section-head bjs-section-head--error">payload</div>
                    <pre class="bjs-pre">{{ formatJson(selectedItem.failed_job.payload) }}</pre>
                </div>

                <!-- debug context -->
                <div v-if="parsedDebugContext.length > 0" class="bjs-detail__section">
                    <div class="bjs-section-head bjs-section-head--warn">Debug Context</div>
                    <div class="bjs-debug">
                        <div v-for="(entry, idx) in parsedDebugContext" :key="idx" class="bjs-debug__entry">
                            <div class="bjs-debug__logic">
                                <span class="bjs-debug__idx">{{ idx + 1 }}</span>
                                <span class="bjs-debug__name">{{ entry.logic }}</span>
                            </div>
                            <pre class="bjs-pre bjs-pre--sm">{{ entry.params }}</pre>
                        </div>
                    </div>
                </div>

                <!-- exception -->
                <div class="bjs-detail__section">
                    <div class="bjs-section-head bjs-section-head--error">exception</div>
                    <pre class="bjs-pre bjs-pre--error bjs-pre--scroll">{{ exceptionWithoutDebugContext }}</pre>
                </div>
            </div>

            <!-- failed_job 없음 안내 -->
            <div v-else-if="selectedItem.status === 9" class="bjs-detail__section">
                <div class="bjs-section-head bjs-section-head--error">failed_jobs</div>
                <p class="bjs-detail__no-fj">failed_job_id = NULL (failed_jobs 레코드 미연결)</p>
            </div>

        </div>
        </transition>

    </div>
</template>

<script>
    export default {
        props: {
            csrfToken: String,
        },
        data: function () {
            return {
                loading: true,
                items: [],
                page: 1,
                lastPage: 1,
                total: 0,
                filterStatus: '',
                filterJobType: '',
                selectedItem: null,
                retrying: false,
                statusCounts: {},
                autoRefresh: false,
                refreshCountdown: 30,
                refreshTimer: null,
                countdownTimer: null,
            };
        },
        computed: {
            statusCountTotal: function () {
                var c = this.statusCounts;
                return (c[1] || 0) + (c[2] || 0) + (c[3] || 0) + (c[9] || 0);
            },

            parsedDebugContext: function () {
                if (!this.selectedItem || !this.selectedItem.failed_job || !this.selectedItem.failed_job.exception) {
                    return [];
                }
                var text = this.selectedItem.failed_job.exception;
                var marker = '\n\n[Debug Context]';
                var pos = text.indexOf(marker);
                if (pos === -1) return [];

                var contextBlock = text.substring(pos + marker.length);
                var entries = [];
                var logicPattern = /\[Logic\]\s*(.+)/g;
                var match;

                while ((match = logicPattern.exec(contextBlock)) !== null) {
                    var logicName = match[1].trim();
                    var afterLogic = contextBlock.substring(match.index + match[0].length);
                    var nextLogicIdx = afterLogic.search(/\[Logic\]/);
                    var paramSection = nextLogicIdx !== -1 ? afterLogic.substring(0, nextLogicIdx) : afterLogic;
                    var paramMatch = paramSection.match(/\[Params\]\s*([\s\S]*)/);
                    var params = paramMatch ? paramMatch[1].trim() : '';
                    entries.push({ logic: logicName, params: params });
                }
                return entries;
            },

            exceptionWithoutDebugContext: function () {
                if (!this.selectedItem || !this.selectedItem.failed_job || !this.selectedItem.failed_job.exception) {
                    return '';
                }
                var text = this.selectedItem.failed_job.exception;
                var marker = '\n\n[Debug Context]';
                var pos = text.indexOf(marker);
                return pos !== -1 ? text.substring(0, pos) : text;
            },
        },
        methods: {
            loadData: function () {
                this.loading = true;
                var cmp = this;

                var params = { page: this.page };
                if (this.filterStatus !== '') params.status = this.filterStatus;
                if (this.filterJobType !== '') params.job_type = this.filterJobType;

                var queryString = Object.keys(params)
                    .map(function (k) { return k + '=' + encodeURIComponent(params[k]); })
                    .join('&');

                $.app.ajax.module.default({
                    type: 'get',
                    url: '/system/background-job-status/list?' + queryString,
                    success: function (response) {
                        cmp.items = response.items;
                        cmp.page = response.pagination.page;
                        cmp.lastPage = response.pagination.last_page;
                        cmp.total = response.pagination.total;
                        if (response.status_counts) {
                            cmp.statusCounts = response.status_counts;
                        }
                        cmp.loading = false;
                    },
                    alert_error_msg: function (msg) {
                        cmp.loading = false;
                        alert('데이터 로드 실패: ' + msg);
                    },
                });
            },

            onFilterChange: function () {
                this.page = 1;
                this.selectedItem = null;
                this.loadData();
            },

            setStatusFilter: function (val) {
                this.filterStatus = val;
                this.onFilterChange();
            },

            goPage: function (newPage) {
                if (newPage < 1 || newPage > this.lastPage) return;
                this.page = newPage;
                this.selectedItem = null;
                this.loadData();
            },

            selectItem: function (item) {
                this.selectedItem = (this.selectedItem && this.selectedItem.id === item.id)
                    ? null
                    : item;
            },

            formatJson: function (obj) {
                try { return JSON.stringify(obj, null, 2); }
                catch (e) { return String(obj); }
            },

            progressPercent: function (item) {
                if (!item.total_count || item.total_count === 0) return 0;
                return Math.round((item.processed_count / item.total_count) * 100);
            },

            shortTime: function (datetime) {
                if (!datetime) return '-';
                // "2026-04-09 14:30:22" → "04-09 14:30"
                var parts = datetime.split(' ');
                if (parts.length < 2) return datetime;
                var datePart = parts[0].substring(5); // "04-09"
                var timePart = parts[1].substring(0, 5); // "14:30"
                return datePart + ' ' + timePart;
            },

            truncate: function (str, len) {
                if (!str) return '';
                return str.length > len ? str.substring(0, len) + '...' : str;
            },

            retryJob: function () {
                if (!confirm('이 작업을 큐에 재등록하시겠습니까?')) return;
                var cmp = this;
                cmp.retrying = true;

                $.app.ajax.module.default({
                    type: 'post',
                    url: '/system/background-job-status/retry',
                    data: {
                        _token: cmp.csrfToken,
                        progress_id: cmp.selectedItem.id,
                    },
                    success: function () {
                        cmp.retrying = false;
                        cmp.selectedItem = null;
                        cmp.loadData();
                    },
                    alert_error_msg: function (msg) {
                        cmp.retrying = false;
                        alert('큐재등록 실패: ' + msg);
                    },
                });
            },

            toggleAutoRefresh: function () {
                this.autoRefresh = !this.autoRefresh;
                if (this.autoRefresh) {
                    this.startAutoRefresh();
                } else {
                    this.stopAutoRefresh();
                }
            },

            startAutoRefresh: function () {
                var cmp = this;
                cmp.refreshCountdown = 30;
                cmp.countdownTimer = setInterval(function () {
                    cmp.refreshCountdown--;
                    if (cmp.refreshCountdown <= 0) {
                        cmp.refreshCountdown = 30;
                        cmp.loadData();
                    }
                }, 1000);
            },

            stopAutoRefresh: function () {
                if (this.countdownTimer) {
                    clearInterval(this.countdownTimer);
                    this.countdownTimer = null;
                }
                this.refreshCountdown = 30;
            },
        },
        mounted: function () {
            this.loadData();
        },
        beforeDestroy: function () {
            this.stopAutoRefresh();
        },
    }
</script>

<style lang="scss" scoped>
/* ============================
   Design Tokens
   ============================ */
$c-slate-900: #0f172a;
$c-slate-800: #1e293b;
$c-slate-700: #334155;
$c-slate-600: #475569;
$c-slate-500: #64748b;
$c-slate-400: #94a3b8;
$c-slate-300: #cbd5e1;
$c-slate-200: #e2e8f0;
$c-slate-100: #f1f5f9;
$c-slate-50:  #f8fafc;
$c-white:     #ffffff;

$c-amber-500: #f59e0b;
$c-amber-400: #fbbf24;
$c-amber-100: #fef3c7;
$c-amber-50:  #fffbeb;

$c-blue-600:  #2563eb;
$c-blue-500:  #3b82f6;
$c-blue-100:  #dbeafe;
$c-blue-50:   #eff6ff;

$c-emerald-600: #059669;
$c-emerald-500: #10b981;
$c-emerald-100: #d1fae5;
$c-emerald-50:  #ecfdf5;

$c-rose-600:  #e11d48;
$c-rose-500:  #f43f5e;
$c-rose-100:  #ffe4e6;
$c-rose-50:   #fff1f2;

$c-orange-500: #f97316;
$c-orange-100: #ffedd5;

$radius:    6px;
$radius-lg: 10px;
$shadow-sm: 0 1px 2px rgba(0,0,0,0.05);
$shadow:    0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06);
$shadow-md: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1);

/* ============================
   Root
   ============================ */
.bjs {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    color: $c-slate-800;
}

/* ============================
   상태 요약 카드
   ============================ */
.bjs-stats {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
    margin-bottom: 16px;
}

.bjs-stat {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 18px;
    background: $c-white;
    border: 1px solid $c-slate-200;
    border-radius: $radius-lg;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;

    &:hover {
        box-shadow: $shadow-md;
        transform: translateY(-1px);
    }

    &.is-active {
        border-width: 2px;
    }
}

.bjs-stat__icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
        width: 22px;
        height: 22px;
    }
}

.bjs-stat__body {
    min-width: 0;
}

.bjs-stat__count {
    font-size: 1.5rem;
    font-weight: 800;
    line-height: 1.1;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
}

.bjs-stat__label {
    font-size: 1rem;
    color: $c-slate-500;
    font-weight: 500;
    margin-top: 2px;
}

/* 카드별 색상 */
.bjs-stat--all {
    .bjs-stat__icon { background: $c-slate-100; color: $c-slate-600; }
    .bjs-stat__count { color: $c-slate-700; }
    &.is-active { border-color: $c-slate-500; }
}
.bjs-stat--pending {
    .bjs-stat__icon { background: $c-amber-100; color: $c-amber-500; }
    .bjs-stat__count { color: $c-amber-500; }
    &.is-active { border-color: $c-amber-500; }
}
.bjs-stat--running {
    .bjs-stat__icon { background: $c-blue-100; color: $c-blue-600; }
    .bjs-stat__count { color: $c-blue-600; }
    &.is-active { border-color: $c-blue-500; }
}
.bjs-stat--completed {
    .bjs-stat__icon { background: $c-emerald-100; color: $c-emerald-600; }
    .bjs-stat__count { color: $c-emerald-600; }
    &.is-active { border-color: $c-emerald-500; }
}
.bjs-stat--failed {
    .bjs-stat__icon { background: $c-rose-100; color: $c-rose-600; }
    .bjs-stat__count { color: $c-rose-600; }
    &.is-active { border-color: $c-rose-500; }
}

/* ============================
   툴바
   ============================ */
.bjs-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background: $c-slate-50;
    border: 1px solid $c-slate-200;
    border-radius: $radius;
    margin-bottom: 12px;
}

.bjs-toolbar__left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.bjs-toolbar__label {
    font-size: 1rem;
    font-weight: 600;
    color: $c-slate-600;
    white-space: nowrap;
}

.bjs-toolbar__select {
    font-size: 1rem;
    padding: 5px 28px 5px 10px;
    border: 1px solid $c-slate-300;
    border-radius: $radius;
    background: $c-white;
    color: $c-slate-700;
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%2364748b'%3E%3Cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 6px center;
    background-size: 16px;

    &:focus {
        border-color: $c-blue-500;
        box-shadow: 0 0 0 2px rgba($c-blue-500, 0.15);
    }
}

.bjs-toolbar__right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.bjs-toolbar__btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 5px 12px;
    font-size: 1rem;
    font-weight: 500;
    color: $c-slate-600;
    background: $c-white;
    border: 1px solid $c-slate-300;
    border-radius: $radius;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;

    &:hover { background: $c-slate-100; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }

    &.is-on {
        background: $c-emerald-50;
        border-color: $c-emerald-500;
        color: $c-emerald-600;
    }
}

.bjs-toolbar__btn-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

.bjs-toolbar__btn--refresh {
    padding: 5px 8px;
}

@keyframes spin { to { transform: rotate(360deg); } }
.is-spinning { animation: spin 0.8s linear infinite; }

/* ============================
   로딩 / 빈 상태
   ============================ */
.bjs-loading {
    text-align: center;
    padding: 60px 20px;
}

.bjs-loading__spinner {
    width: 36px;
    height: 36px;
    border: 3px solid $c-slate-200;
    border-top-color: $c-blue-500;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
    margin: 0 auto 14px;
}

.bjs-loading__text {
    font-size: 1rem;
    color: $c-slate-400;
    margin: 0;
}

.bjs-empty {
    text-align: center;
    padding: 60px 20px;
}

.bjs-empty__icon {
    width: 48px;
    height: 48px;
    color: $c-slate-300;
    margin-bottom: 12px;
}

.bjs-empty__text {
    font-size: 1rem;
    color: $c-slate-400;
    margin: 0;
}

/* ============================
   테이블
   ============================ */
.bjs-table-wrap {
    background: $c-white;
    border: 1px solid $c-slate-200;
    border-radius: $radius-lg;
    overflow: hidden;
}

.bjs-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 1rem;

    thead tr {
        background: $c-slate-800;
    }

    th {
        padding: 10px 12px;
        font-size: 1rem;
        font-weight: 600;
        color: $c-slate-300;
        text-align: left;
        white-space: nowrap;
        text-transform: none;
        letter-spacing: 0;
        border: none;
    }

    td {
        padding: 10px 12px;
        vertical-align: middle;
        border-bottom: 1px solid $c-slate-100;
    }
}

.bjs-th--status {
    width: 6px;
    padding: 0 !important;
}

.bjs-row {
    cursor: pointer;
    transition: background 0.12s;

    &:hover {
        background: $c-slate-50;
    }

    &.is-selected {
        background: $c-blue-50;
    }
}

/* 상태별 행 좌측 테두리 */
.bjs-td--status {
    width: 4px;
    padding: 0 !important;
    position: relative;
}

.bjs-row--s1 .bjs-td--status { background: $c-amber-400; }
.bjs-row--s2 .bjs-td--status { background: $c-blue-500; }
.bjs-row--s3 .bjs-td--status { background: $c-emerald-500; }
.bjs-row--s9 .bjs-td--status { background: $c-rose-500; }

/* 상태 도트 */
.bjs-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: $c-slate-300;
    flex-shrink: 0;

    &--lg {
        width: 12px;
        height: 12px;
    }
}

.bjs-dot--s1 { background: $c-amber-400; }
.bjs-dot--s2 { background: $c-blue-500; animation: pulse-blue 2s infinite; }
.bjs-dot--s3 { background: $c-emerald-500; }
.bjs-dot--s9 { background: $c-rose-500; }

@keyframes pulse-blue {
    0%, 100% { box-shadow: 0 0 0 0 rgba($c-blue-500, 0.4); }
    50% { box-shadow: 0 0 0 5px rgba($c-blue-500, 0); }
}

.bjs-td--id {
    font-weight: 700;
    color: $c-slate-600;
    font-variant-numeric: tabular-nums;
}

.bjs-td--type {
    font-weight: 500;
    white-space: nowrap;
}

.bjs-td--time {
    white-space: nowrap;
    color: $c-slate-500;
    font-variant-numeric: tabular-nums;
    font-size: 1rem;
}

.bjs-td--note {
    max-width: 200px;
}

.bjs-td--progress {
    min-width: 120px;
}

.bjs-td--counts {
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
}

/* 상태 배지 */
.bjs-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 20px;
    font-size: 1rem;
    font-weight: 600;
    white-space: nowrap;
    line-height: 1.4;
}

.bjs-badge--s1 { background: $c-amber-100; color: #92400e; }
.bjs-badge--s2 { background: $c-blue-100; color: #1e40af; }
.bjs-badge--s3 { background: $c-emerald-100; color: #065f46; }
.bjs-badge--s9 { background: $c-rose-100; color: #9f1239; }

/* 프로그레스 바 */
.bjs-progress {
    position: relative;
    height: 20px;
    background: $c-slate-100;
    border-radius: 10px;
    overflow: hidden;
}

.bjs-progress--lg {
    height: 26px;
    border-radius: 13px;
}

.bjs-progress__bar {
    height: 100%;
    border-radius: 10px;
    transition: width 0.4s ease;
    min-width: 0;
}

.bjs-progress__bar--s1 { background: $c-amber-400; }
.bjs-progress__bar--s2 {
    background: repeating-linear-gradient(
        -45deg,
        $c-blue-500,
        $c-blue-500 8px,
        $c-blue-600 8px,
        $c-blue-600 16px
    );
    background-size: 22.6px 100%;
    animation: stripe-move 0.8s linear infinite;
}
.bjs-progress__bar--s3 { background: $c-emerald-500; }
.bjs-progress__bar--s9 { background: $c-rose-500; }

@keyframes stripe-move {
    0% { background-position: 0 0; }
    100% { background-position: 22.6px 0; }
}

.bjs-progress__text {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-weight: 600;
    color: $c-slate-700;
    mix-blend-mode: multiply;
    font-variant-numeric: tabular-nums;
}

/* 성공/실패 카운트 */
.bjs-count-ok { color: $c-emerald-600; font-weight: 600; }
.bjs-count-fail { color: $c-rose-600; font-weight: 700; }
.bjs-count-zero { color: $c-slate-400; font-weight: 500; }
.bjs-count-sep { color: $c-slate-300; margin: 0 2px; }

/* 비고 */
.bjs-note-fjid {
    display: inline-block;
    padding: 1px 6px;
    background: $c-rose-100;
    color: $c-rose-600;
    border-radius: 3px;
    font-size: 1rem;
    font-weight: 600;
    margin-right: 4px;
    font-variant-numeric: tabular-nums;
}

.bjs-note-err {
    display: inline-block;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: $c-rose-500;
    font-size: 1rem;
    vertical-align: middle;
}

/* ============================
   페이저
   ============================ */
.bjs-pager {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px;
    border-top: 1px solid $c-slate-100;
}

.bjs-pager__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid $c-slate-200;
    border-radius: $radius;
    background: $c-white;
    color: $c-slate-600;
    cursor: pointer;
    transition: all 0.15s;

    svg { width: 18px; height: 18px; }

    &:hover:not(:disabled) { background: $c-slate-100; }
    &:disabled { opacity: 0.35; cursor: not-allowed; }
}

.bjs-pager__info {
    font-size: 1rem;
    font-weight: 600;
    color: $c-slate-700;
    padding: 0 8px;
    font-variant-numeric: tabular-nums;
}

.bjs-pager__total {
    font-weight: 400;
    color: $c-slate-400;
}

/* ============================
   상세 패널
   ============================ */
.bjs-slide-enter-active, .bjs-slide-leave-active {
    transition: all 0.25s ease;
}
.bjs-slide-enter, .bjs-slide-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

.bjs-detail {
    margin-top: 16px;
    background: $c-white;
    border: 1px solid $c-slate-200;
    border-radius: $radius-lg;
    overflow: hidden;
}

.bjs-detail__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: $c-slate-800;
    color: $c-white;
}

.bjs-detail__title-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.bjs-detail__title {
    font-size: 1.1rem;
    font-weight: 700;
    margin: 0;
    color: $c-white;
}

.bjs-detail__actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* 버튼 */
.bjs-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 14px;
    font-size: 1rem;
    font-weight: 600;
    border-radius: $radius;
    border: none;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;

    &:disabled { opacity: 0.5; cursor: not-allowed; }
}

.bjs-btn__icon {
    width: 16px;
    height: 16px;
}

.bjs-btn--danger {
    background: $c-rose-500;
    color: $c-white;

    &:hover:not(:disabled) { background: $c-rose-600; }
}

.bjs-btn--ghost {
    background: transparent;
    color: $c-slate-300;
    border: 1px solid $c-slate-600;

    &:hover { background: $c-slate-700; color: $c-white; }
}

/* 메타 그리드 */
.bjs-detail__meta {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    border-bottom: 1px solid $c-slate-100;
}

.bjs-meta-item {
    padding: 12px 20px;
    border-right: 1px solid $c-slate-100;

    &:nth-child(3n) { border-right: none; }
    &:nth-child(n+4) { border-top: 1px solid $c-slate-100; }
}

.bjs-meta-item__label {
    display: block;
    font-size: 1rem;
    color: $c-slate-400;
    font-weight: 500;
    margin-bottom: 3px;
}

.bjs-meta-item__value {
    display: block;
    font-size: 1rem;
    font-weight: 600;
    color: $c-slate-800;
    font-variant-numeric: tabular-nums;

    &.is-danger {
        color: $c-rose-600;
    }
}

/* 진행률 상세 */
.bjs-detail__progress-section {
    padding: 16px 20px;
    border-bottom: 1px solid $c-slate-100;
}

.bjs-detail__progress-counts {
    display: flex;
    gap: 24px;
    margin-top: 12px;
}

.bjs-progress-count {
    text-align: center;
}

.bjs-progress-count__num {
    display: block;
    font-size: 1.25rem;
    font-weight: 800;
    color: $c-slate-700;
    line-height: 1.2;
    font-variant-numeric: tabular-nums;
}

.bjs-progress-count__label {
    font-size: 1rem;
    color: $c-slate-400;
    font-weight: 500;
}

.bjs-progress-count--ok .bjs-progress-count__num { color: $c-emerald-600; }
.bjs-progress-count--fail .bjs-progress-count__num { color: $c-rose-600; }

/* 섹션 */
.bjs-detail__section {
    padding: 12px 20px 16px;
}

.bjs-detail__section--error {
    background: $c-rose-50;
    border-bottom: 1px solid $c-rose-100;
}

.bjs-section-head {
    font-size: 1rem;
    font-weight: 700;
    color: $c-slate-500;
    background: $c-slate-100;
    display: inline-block;
    padding: 3px 10px;
    border-radius: 4px;
    margin-bottom: 8px;
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
}

.bjs-section-head--error {
    background: $c-rose-500;
    color: $c-white;
}

.bjs-section-head--warn {
    background: $c-amber-500;
    color: $c-white;
}

/* pre 블록 */
.bjs-pre {
    background: $c-slate-50;
    border: 1px solid $c-slate-200;
    border-radius: $radius;
    padding: 12px 14px;
    font-size: 1rem;
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
    white-space: pre-wrap;
    word-break: break-all;
    margin: 0;
    color: $c-slate-700;
    line-height: 1.5;
}

.bjs-pre--error {
    background: $c-rose-50;
    border-color: $c-rose-100;
    color: $c-rose-600;
}

.bjs-pre--scroll {
    max-height: 400px;
    overflow-y: auto;
}

.bjs-pre--sm {
    padding: 8px 10px;
    font-size: 1rem;
}

/* failed 섹션 */
.bjs-detail__failed {
    border-top: 3px solid $c-rose-500;
    background: $c-rose-50;
}

.bjs-detail__failed-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px 20px 0;
    font-size: 1rem;
    font-weight: 800;
    color: $c-rose-600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.bjs-detail__failed-icon {
    width: 20px;
    height: 20px;
    color: $c-rose-500;
}

.bjs-detail__failed-meta {
    display: flex;
    gap: 20px;
    padding: 10px 20px 14px;
    font-size: 1rem;
    color: $c-slate-600;

    strong {
        color: $c-slate-700;
    }
}

.bjs-detail__no-fj {
    color: $c-slate-400;
    font-size: 1rem;
    margin: 0;
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
}

/* Debug Context */
.bjs-debug {
    border: 1px solid #e0c46c;
    border-radius: $radius;
    background: #fffbe6;
    padding: 10px 12px;
}

.bjs-debug__entry {
    margin-bottom: 10px;

    &:last-child { margin-bottom: 0; }
}

.bjs-debug__logic {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.bjs-debug__idx {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: $c-rose-500;
    color: $c-white;
    font-size: 1rem;
    font-weight: 700;
    flex-shrink: 0;
}

.bjs-debug__name {
    font-size: 1rem;
    font-weight: 600;
    color: $c-slate-800;
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
}
</style>
